const BASE = process.env.REACT_APP_BACKEND_URL + "/api";

export const API = BASE;

export const getToken = () => sessionStorage.getItem("wv_token");
export const setToken = (t) => sessionStorage.setItem("wv_token", t);
export const removeToken = () => sessionStorage.removeItem("wv_token");
export const isAuthenticated = () => !!getToken();

export const authFetch = async (url, options = {}) => {
  const token = getToken();
  const headers = { ...options.headers };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  if (options.body && typeof options.body === "string" && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  const res = await fetch(url, { ...options, headers });
  if (res.status === 401) {
    removeToken();
    window.location.href = "/login";
    return null;
  }
  return res;
};
